import type { ReportResponse } from "@/types/report"
import type { ReportList } from "@/types/report-list"
import type { ProjectSummaryDto } from "@/types/project"
import type { DirectorTenant } from "@/types/director"

export const demoReports: ReportResponse[] = [
  {
    reportKey: "demo-report-1",
    name: "Project Summary Report",
    path: "Reports/ProjectSummary",
    tenantId: 1,
    description: "A comprehensive summary of project status and metrics",
    isHidden: false,
    displayName: "Project Summary",
    reportVersion: "1.0",
    lastModifiedDateTime: new Date().toISOString(),
    lastModifiedUserKey: "demo-user",
    createdDateTime: new Date().toISOString(),
    createdUserKey: "demo-user",
  },
  {
    reportKey: "demo-report-2",
    name: "Financial Overview",
    path: "Reports/FinancialOverview",
    tenantId: 1,
    description: "Financial metrics and budget tracking",
    isHidden: false,
    displayName: "Financial Overview",
    reportVersion: "1.0",
    lastModifiedDateTime: new Date().toISOString(),
    lastModifiedUserKey: "demo-user",
    createdDateTime: new Date().toISOString(),
    createdUserKey: "demo-user",
  },
  {
    reportKey: "demo-report-3",
    name: "Resource Allocation",
    path: "Reports/ResourceAllocation",
    tenantId: 1,
    description: "Team and resource allocation details",
    isHidden: false,
    displayName: "Resource Allocation",
    reportVersion: "1.0",
    lastModifiedDateTime: new Date().toISOString(),
    lastModifiedUserKey: "demo-user",
    createdDateTime: new Date().toISOString(),
    createdUserKey: "demo-user",
  },
]

export const demoReportLists: ReportList[] = [
  {
    reportListKey: "demo-list-1",
    name: "Demo Report List",
    tenantId: 1,
    reportListItems: [],
    createdUserKey: "demo-user",
    lastModifiedUserKey: "demo-user",
    createdDateTime: new Date().toISOString(),
    lastModifiedDateTime: new Date().toISOString(),
  },
]

export const demoProjects: ProjectSummaryDto[] = [
  {
    tenantId: 1,
    projectId: 1,
    projectNumber: "DEMO-001",
    name: "Demo Project Alpha",
    isActive: true,
    isArchived: false,
  },
  {
    tenantId: 1,
    projectId: 2,
    projectNumber: "DEMO-002",
    name: "Demo Project Beta",
    isActive: true,
    isArchived: false,
  },
]

export const demoCurrentTenant: DirectorTenant = {
  id: 1,
  name: "Demo Tenant",
  tenantTypeId: 1,
}
